export default __webpack_public_path__ + "static/media/community.4baca058.JPG";